import { BlockType } from '../../types/index.js';
import { IconBlock as Component } from './Block.js';
export const RegisteredIconBlock = (_intl) => ({
    recommendedName: 'Icon',
    Component,
    config: { type: BlockType.BuildingBlock },
});
//# sourceMappingURL=registered.js.map